import React from "react";
import { Provider as JotaiProvider } from "jotai";

export const StateProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <JotaiProvider>{children}</JotaiProvider>;
